// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import layout from './pages/layout'
import router from './router'
import store from './store/index.js'
import Vant from 'vant';
import Calendar from 'vue-mobile-calendar'

import 'vant/lib/vant-css/index.css';
// 引用API文件
import api from './api/index.js'


Vue.use(Calendar)
// 将API方法绑定到全局
Vue.prototype.$api = api
Vue.use(Vant)
Vue.config.productionTip = false
/* eslint-disable no-new */

//系统错误捕获
const errorHandler = (error, vm)=>{
  console.error('抛出全局异常');
  console.error(vm);
  console.error(error);
}

Vue.config.errorHandler = errorHandler;
Vue.prototype.$throw = (error)=> errorHandler(error,this);

new Vue({
  el: '#app',
  router,
  store,
  components: { layout },
  template: '<layout/>'
})



// WEBPACK FOOTER //
// ./src/main.js